import { reloadPage, goBack } from './ErrorFallback.helpers';

export const VARIANTS = ['tile', 'page', 'app'];

// What each size says and offers. `retry` is the boundary's in-place retry;
// the app shell has nothing above it to retry into, so it reloads instead.
export const VARIANT_CONFIG = {
  tile: {
    illustrationWidth: 72,
    title: ['common.errorBoundary.tileTitle', "This section couldn't load"],
    message: null,
    primary: { label: ['common.errorBoundary.retry', 'Try again'], action: 'retry' },
    secondary: null
  },
  page: {
    illustrationWidth: 120,
    title: ['common.errorBoundary.pageTitle', 'This page ran into a problem'],
    message: ['common.errorBoundary.pageMessage', 'Everything else still works. Try again, or head back.'],
    primary: { label: ['common.errorBoundary.retry', 'Try again'], action: 'retry' },
    secondary: { label: ['common.errorBoundary.goBack', 'Go back'], action: goBack }
  },
  app: {
    illustrationWidth: 140,
    title: ['common.errorBoundary.appTitle', 'Something went wrong'],
    message: ['common.errorBoundary.appMessage', 'Reloading usually fixes this.'],
    primary: { label: ['common.errorBoundary.reload', 'Reload page'], action: reloadPage },
    secondary: null
  }
};
